export default __webpack_public_path__ + "static/strategy-and-design-6ca200135e6c38a451e1380c2c7666c2.jpg";